import PeriodDataStore from '../datastores/PeriodDataStore';
import PeriodDataStoreGraphQL from '../datasources/graphql/period';
import PeriodDataStoreMock from '../datasources/mock/period';
import config from '../../core/config/config';

export default class PeriodDataStoreFactory {
  static create(): PeriodDataStore {
    if (config.DATASOURCE_ENV === 'MOCK') {
      return new PeriodDataStoreMock();
    }
    return new PeriodDataStoreGraphQL();
  }
}
